const excludeProps = (obj, propsToExclude) => {
  return Object.keys(obj).reduce((newObj, key) => {
    if (!propsToExclude.includes(key)) {
      newObj[key] = {
        value: obj[key],
      };
    }
    return newObj;
  }, {});
};
export default excludeProps;
